import { useEffect, useRef } from "react";

export const useSkipFirstEffect = (callback, dependencies) => {
    const firstRenderRef = useRef(true);

    useEffect(() => {
        if (firstRenderRef.current) {
            firstRenderRef.current = false;
        } else {
            callback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...dependencies]);
};
